import { LocalStorageController } from '../util/local-storage-controller';

export const END_TO_END_TOKEN_KEY = 'TeamEngine.EndToEndToken';

export const getEndToEndUserToken = () => {
  const fullJwtToken = LocalStorageController.getItem(END_TO_END_TOKEN_KEY);
  if (!fullJwtToken) return null;
  return fullJwtToken;
};
